<template>
	<div class="market-view">
        <chillNavbar path_title="current_visit" :current_visit="singleMarket.store_name_app" betreiber="REWE Nord" />
        <!-- <div class="market-address-box" >
            <div class="address-box-section">
                <span class="title-address">{{trans('address')}}</span>
                <span class="title-address-value">{{trans(singleMarket.city)}}</span>
                <span class="title-address-value">{{trans(singleMarket.street)}}</span>
            </div>
            <div class="address-box-section">
                <span class="title-address">{{trans('owner')}}</span>
                <span class="title-address-value">{{trans(singleMarket.owner)}}</span>
            </div>
        </div> -->
        <div class="market-new-visit">
            <h3>{{trans('press_a_button_to_start_a_visit')}}</h3>
            <div class="select-box">
                <button class="button-box-element" :class="newVisitType == 'heating' ? 'active' : ''" @click="newVisitType = 'heating', newVisit()">
                    <chill-icon class="dark new-tab-one-icon big-icon" icon="repositioned_sensor"/>
                    <span>{{trans('heating')}}</span>
                </button>
                <button class="button-box-element" :class="newVisitType == 'ventilation' ? 'active' : ''" @click="newVisitType = 'ventilation', newVisit()" >
                    <chill-icon class="dark new-tab-one-icon big-icon" icon="outlet"/>
                    <span>{{trans('ventilation')}}</span>
                </button>
                <button class="button-box-element" :class="newVisitType == 'air_conditioning' ? 'active' : ''" @click="newVisitType = 'air_conditioning', newVisit()">
                    <chill-icon class="dark new-tab-one-icon big-icon" icon="air_con"/>
                    <span>{{trans('air_conditioning')}}</span>
                </button>
            </div>
        </div>

        <div class="list-of-visits">
            <h3>{{trans('recent_visits')}}</h3>
            <div class="visit-scroll-box">
                <div class="visit-row"  @click="toVisit(v.visit_id, v.count, v.craft, v.locked)" v-for="v in rev(visits)" v-bind:key="v.id">
                    <span v-if="!v.locked" class="visit-text">{{trans(v.craft)}}, {{trans('started_at')}}: {{trans(v.started_at)}}</span>
                    <span v-else class="visit-text">{{trans(v.craft)}}, {{trans('signed_at')}}: {{trans(v.locked_at)}}</span>
                </div>

            </div>
        </div>
        <!-- market {{singleMarket}}
        <li @click="toVisit(v.visit_id, v.count)" v-for="v in visits" v-bind:key="v.id">{{v}}</li> -->
	</div>
</template>


<script>
	export default {
		name: 'market',
		data() {
			return {
				newVisitType: ""
			}
		},
		beforeRouteLeave(to, form , next){
			this.clearMarketData();
			this.clearVisitData();
			next()
		},
		computed: {

		},
		methods: {
            setVisitTyp(type) {
                if(this.newVisitType == type)
                    this.newVisitType = ''
                else
                    this.newVisitType = type
            },
            rev(array){
                return array.slice().reverse()
            },
			async toVisit(visit_id, visit_count,visit_craft, locked){
                if(locked){
                    this.$router.push({ path: `/done_visit/${this.$route.params.market_id}/${visit_id}` });
                }
				else if(!visit_count){
					this.$router.push({ path: `/count/${this.$route.params.market_id}/${visit_id}/${visit_craft}` });
				}else{
					this.$router.push({ path: `/visit/${this.$route.params.market_id}/${visit_id}` });
				}
			},
			async newVisit(){
				let id = await this.createNewVisit(this.$route.params.market_id, this.newVisitType, this.singleMarket.owner, localStorage.getItem("user_client"))
				this.$router.push({ path: `/count/${this.$route.params.market_id}/${id}/${this.newVisitType}` });
			}
		},
		mounted(){
			this.startSingleMarketListener(this.$route.params.market_id)
			this.startVisitsListener(this.$route.params.market_id)
            this.startUserListener()
		}
	}
</script>

<style scoped lang="scss">
    .market-view {
        margin: 150px auto 0px auto;
        width: 86vw;
        max-width: 900px;
        height: calc(100vh - 140px);
        .market-new-visit {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .select-box {
                display: flex;
                .button-box-element {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    width: 100%;
                    background-color: #fff;
                    min-height: 56px;
                    border-radius: 4px;
                    border: none;
                    margin: 4px;
                    padding: 6px;
                    font-weight: 300;
                    font-size: 14px;
                    &:hover {
                        cursor: pointer;
                    }
                }
                .active {
                    background-color: #1B608C;
                    color: white;
                    opacity: 1;
                }
            }
        }
        .list-of-visits {
            display: flex;
            flex-direction: column;
            margin: 0px auto;
            margin-top: 12px;
            height: calc(100vh - 280px);
            overflow: auto;
            .visit-scroll-box {
                overflow-y: auto;
                max-height: calc(100vh - 300px);
                -ms-overflow-style: none;  /* Internet Explorer 10+ */
                scrollbar-width: none;  /* Firefox */
                &::-webkit-scrollbar { 
                    display: none;  /* Safari and Chrome */
                }
                .visit-row {
                    margin: 8px 0px;
                    height: 56px;
                    background-color: #fff;
                    display: flex;
                    justify-content: space-between;
                    border-left: solid #1B608C 5px;
                    &:hover {
                        cursor: pointer;
                        border-left: solid #4FC4F0 5px;
                    }
                    .visit-text {
                        margin: auto;
                        margin-left: 8px;
                        font-weight: 300;
                    }
                }
            }
        }
    }
    // // belongs to out comment template
    // .market-address-box {
    //     border: solid #707070 1px;
    //     border-radius: 4px;
    //     margin-bottom: 20px;
    //     padding: 10px;
    // }
    // .address-box-section {
    //     display: flex;
    //     flex-direction: column;
    //     margin-bottom: 8px;
    // }
    // .title-address-value {
    //     font-weight: 600;
    //     color: #1B608C;
    // }
 

    
 
    h3 {
        font-weight: normal;
        font-size: 16px;
        margin-top: 0px;
    }
    span {
        font-size: 14px;
        font-weight: 300;
    }
    button {
        font-family: 'Yantramanav', Verdana, Arial, Helvetica, sans-serif;
    }

</style>